import React, { useEffect, useRef, useState } from 'react'
import LocationOnIcon from '@mui/icons-material/LocationOn'
import SearchIcon from '@mui/icons-material/Search'
import '../../styles/FeaturedServices.scss'
import FeaturedServiceCard from '../../components/Cards/FeaturedServiceCard'
import SelectLocationModal from '../../modals/SelectLocationModal'
import ServiceTypesModal from '../../modals/ServiceTypesModal'
import ServicesModal from '../../components/ServicesModal'
import { getAllData, getDataById } from '../../apis/generalApis'

const containerStyle = {
  width: '800px',
  height: '800px',
}
const center = {
  lat: 48.8584,
  lng: 2.2945,
}

const FeaturedServices = ({ screenName }) => {
  let user = JSON.parse(localStorage.getItem('user'))
  const searchInputRef = useRef()
  let clientLocation = JSON.parse(localStorage.getItem('client_location'))
  const [selectLocationModal, setSelectLocationModal] = useState(false)
  const [serviceTypeModal, setServiceTypeModal] = useState(false)
  const [selectedService, setSelectedService] = useState({})
  const [servicesModal, setServicesModal] = useState(false)
  const [zipCode, setZipCode] = useState('')
  useEffect(() => {}, [])

  useEffect(() => {
    // console.log({ zipCode })
    getServices({ zipCode: Number(zipCode) })
  }, [zipCode])

  const [center, setCenter] = React.useState(
    clientLocation ?? {
      lat: Number(user?.latitude),
      lng: Number(user?.longitude),
    },
  )
  const [mapCenter, setMapCenter] = React.useState({
    ...center,
  })
  const [value, setValue] = React.useState(null)

  const [clientHomeServices, setClientHomeServices] = useState([])
  const [initialServices, setInitialServices] = useState([])
  const [serviceQuery, setServiceQuery] = useState('')

  const getServices = async (body = {}) => {
    let result = await getAllData('show-stylist-services')
    if (result?.success === true) {
      setClientHomeServices(result?.data)
      setInitialServices(result?.data)
    }
  }

  const handleSelectLocationModal = () => {
    setSelectLocationModal(!selectLocationModal)
  }
  const handleServiceTypesModal = () => {
    setServiceTypeModal(!serviceTypeModal)
  }
  const handleServicesModal = () => {
    setServicesModal(!servicesModal)
  }
  const handleServiceSearch = (e) => {
    if (searchInputRef.current?.value !== '') {
      setClientHomeServices((prev) =>
        initialServices?.filter((service) => {
          let serviceName = service?.subservice?.name?.toLowerCase()
          if (
            serviceName?.includes(
              searchInputRef.current?.value.replace(/ /g, ''),
            )
          ) {
            return service
          }
        }),
      )
    } else {
      setClientHomeServices(initialServices)
    }
  }


  const handleEnterPress = async (e) => {
    if (e.key === 'Enter') {
      let result
      if (serviceQuery === '') {
        getServices({})
      } else {
        result = await getDataById('search-services', {
          query: serviceQuery,
        })
      }
      if (result?.success === true && result?.data) {
        setClientHomeServices(result?.data)
      }
    }
  }

  // console.log({ zipCode })

  return (
    <div className="container">
      <div className="featured-services text-center">
        <div className="input-location">
          <div className="h-100 input-locaiton-wrapper py-2 d-flex align-items-center justify-content-between">
            <div className="search-input h-100 d-flex align-items-center">
              <SearchIcon className="search-icon" />
              <input
                type="text"
                name="search-query"
                className="fs-18"
                placeholder="Search For Services"
                onChange={handleServiceSearch}
                // onKeyDown={handleEnterPress}
                ref={searchInputRef}
                // value={serviceQuery ?? ''}
              />
            </div>
            <div
              className="location-btn px-2 py-1 pointer"
              onClick={handleSelectLocationModal}
            >
              <p className="m-0 text-white">
                <LocationOnIcon
                  className="location-icon"
                  style={{ width: '1rem' }}
                />{' '}
                {value ? value.label : 'Select Location'}
              </p>
            </div>
          </div>
        </div>
        <h1 className="main-heading">Featured Services</h1>
        <div className="row mt-5 gy-4 flex-nowrap overflow-auto pb-3">
          {clientHomeServices?.map(
            (service, index) =>
              service?.service?.is_feature === true && (
                <div
                  className="col-12 col-sm-6 col-md-6 col-lg-3 pointer"
                  key={service?.id}
                  onClick={() => {
                    handleServiceTypesModal()
                    setSelectedService(service)
                  }}
                >
                  <FeaturedServiceCard
                    service={service}
                    className="client-dashboard"
                  />
                </div>
              ),
          )}
          <h3 className='text-center text-black'>No Featured Services Found.</h3>
        </div>
        <h1 className="main-heading services-heading">Services</h1>
        <div className="row mt-4 gy-4 pb-3 flex-nowrap overflow-auto">
          {clientHomeServices?.map(
            (service, index) =>
              service?.service?.is_feature === false && (
                <div
                  className="col-12 col-sm-6 col-md-6 col-lg-3 pointer"
                  key={service?.id}
                  onClick={() => {
                    handleServiceTypesModal()
                    setSelectedService(service)
                  }}
                >
                  <FeaturedServiceCard
                    service={service}
                    className="client-dashboard"
                  />
                </div>
              ),
          )}
        </div>
      </div>
      <SelectLocationModal
        handleSelectLocationModal={handleSelectLocationModal}
        selectLocationModal={selectLocationModal}
        mapCenter={mapCenter}
        value={value}
        setValue={setValue}
        setCenter={setCenter}
        setZipCode={setZipCode}
        center={center}
      />
      <ServiceTypesModal
        handleServiceTypesModal={handleServiceTypesModal}
        modalOpen={serviceTypeModal}
        screenName="client-dashboard-features-list"
        service={selectedService}
      />
      <ServicesModal
        handleServicesModal={handleServicesModal}
        modalOpen={servicesModal}
        screenName="client-home-screen"
      />
    </div>
  )
}

export default FeaturedServices
